import React from 'react';
import { Empty, Tabs } from 'antd';
import PageTitle from '@/components/PageTitle';
import { checkPermission } from '@/utils/permission';
import CommissionPayoutPage from './CommissionPayoutPage';
import CommissionPayoutSchedulePage from './CommissionPayoutSchedulePage';
import useCommissionTabs from './useCommissionTabs';

const { TabPane } = Tabs;

export default function CommissionPayoutHubPage() {
    const tabs = [
        { key: 'payouts', label: 'Danh sách chi trả', allowed: checkPermission('commission_payout', 'view'), content: <CommissionPayoutPage embedded /> },
        { key: 'schedules', label: 'Lịch chi trả', allowed: checkPermission('commission_payout_schedule', 'view'), content: <CommissionPayoutSchedulePage embedded /> },
    ].filter(tab => tab.allowed);
    const { activeTabKey, onTabChange } = useCommissionTabs(tabs);
    return <div>
        <PageTitle routes={[{ path: '/', breadcrumbName: 'Trang chủ' }, { path: '#', breadcrumbName: 'Chi trả hoa hồng' }]} title="Chi trả hoa hồng" />
        {tabs.length ? <Tabs activeKey={activeTabKey} onChange={onTabChange} destroyInactiveTabPane>{tabs.map(tab => <TabPane tab={tab.label} key={tab.key}>{tab.content}</TabPane>)}</Tabs> : <Empty description="Bạn chưa có quyền xem chức năng chi trả." />}
    </div>;
}
